export * from './lib/new-customer-contact/new-customer-contact.component';
